import { ActionStatus } from './ActionStatus';
import { buildActionType } from './buildActionType';

const initialState = { counter: 0, version: 0 };

const countReducer =
  actionType =>
  (state = initialState, action) => {
    switch (action.type) {
      case buildActionType(actionType, ActionStatus.START):
        return { counter: ++state.counter, version: +new Date() };

      case buildActionType(actionType, ActionStatus.DONE):
        return { counter: --state.counter, version: +new Date() };

      case buildActionType(actionType, ActionStatus.RESET):
        return { counter: 0, version: 0 };

      default:
        return state;
    }
  };

export { countReducer };
